import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ApiConstants } from '../constants/api-constants';

@Injectable({ providedIn: 'root' })
export class ParentsService {
  private get url() { return ApiConstants.URL_PARENTS; }

  constructor(private http: HttpClient) {}

  async list(): Promise<any[]> {
    const response = await firstValueFrom(this.http.get<any>(this.url));
    return response.data;
  }

  async getById(id: string): Promise<any> {
    const response = await firstValueFrom(this.http.get<any>(`${this.url}/${id}`));
    return response.data;
  }

  async create(body: Record<string, unknown>): Promise<any> {
    const response = await firstValueFrom(this.http.post<any>(this.url, body));
    return response.data;
  }

  async update(id: string, body: Record<string, unknown>): Promise<any> {
    const response = await firstValueFrom(this.http.patch<any>(`${this.url}/${id}`, body));
    return response.data;
  }

  async delete(id: string): Promise<any> {
    const response = await firstValueFrom(this.http.delete<any>(`${this.url}/${id}`));
    return response.data;
  }
}
